import React from "react";

export const SoftCircle = ({ className = "", color = "#A9D4FF" }) => (
  <svg viewBox="0 0 80 80" aria-hidden="true" className={className}>
    <circle cx="40" cy="40" r="28" fill={color} />
  </svg>
);

export const Squircle = ({ className = "", color = "#B8F0D2" }) => (
  <svg viewBox="0 0 80 80" aria-hidden="true" className={className}>
    <rect x="14" y="14" width="52" height="52" rx="18" fill={color} />
  </svg>
);

export const MiniStar = ({ className = "", color = "#FFE27A" }) => (
  <svg viewBox="0 0 80 80" aria-hidden="true" className={className}>
    <path
      fill={color}
      d="M40 10 L48 32 L70 34 L52 48 L58 70 L40 58 L22 70 L28 48 L10 34 L32 32 Z"
    />
  </svg>
);

export const Squiggle = ({ className = "", color = "#FFB3D1" }) => (
  <svg viewBox="0 0 80 40" aria-hidden="true" className={className}>
    <path
      d="M6 24 C18 8 28 8 40 24 S62 40 74 16"
      fill="none"
      stroke={color}
      strokeWidth="8"
      strokeLinecap="round"
    />
  </svg>
);

export const Ground = ({ className = "" }) => (
  <svg viewBox="0 0 80 24" aria-hidden="true" className={`char-ground ${className}`}>
    <ellipse cx="40" cy="14" rx="28" ry="6" fill="#1A1428" opacity="0.12" />
  </svg>
);

export const StampCalendar = ({ className = "", color = "#5B4A9C" }) => (
  <svg viewBox="0 0 64 64" aria-hidden="true" className={className}>
    <rect x="10" y="16" width="44" height="38" rx="10" fill="none" stroke={color} strokeWidth="6" />
    <path d="M10 28 H54" fill="none" stroke={color} strokeWidth="6" strokeLinecap="round" />
    <path d="M22 8 V20 M42 8 V20" fill="none" stroke={color} strokeWidth="6" strokeLinecap="round" />
  </svg>
);

export const StampCoin = ({ className = "", color = "#5B4A9C" }) => (
  <svg viewBox="0 0 64 64" aria-hidden="true" className={className}>
    <circle cx="32" cy="32" r="22" fill="none" stroke={color} strokeWidth="6" />
    <circle cx="32" cy="32" r="7" fill={color} />
  </svg>
);

export const StampStory = ({ className = "", color = "#5B4A9C" }) => (
  <svg viewBox="0 0 64 64" aria-hidden="true" className={className}>
    <rect x="16" y="8" width="32" height="48" rx="12" fill="none" stroke={color} strokeWidth="6" />
    <circle cx="32" cy="28" r="6" fill={color} />
    <path d="M24 46 H40" fill="none" stroke={color} strokeWidth="6" strokeLinecap="round" />
  </svg>
);
